import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="profile">
      <div className="hero-container">
        <div className="hero-content">
          {/* Profile Image */}
          <div className="profile-image-container">
            <img 
              src="/assets/profile.jpg" 
              alt="Dr. Rajkamal Upadhyaya"
              className="profile-image"
              onError={(e) => {
                e.target.style.display = 'none';
                document.querySelector('.profile-placeholder').style.display = 'flex';
              }}
            />
            <div className="profile-placeholder">
              <span className="placeholder-text">DR</span>
            </div>
          </div>

          {/* Profile Information */}
          <div className="profile-info">
            <div className="profile-badge">Professor & Researcher</div>
            <h1 className="hero-title">
              Dr. <span className="highlight">Rajkamal Upadhyaya</span>
            </h1>
            <p className="hero-subtitle">
              Accounting & Financial Management Specialist
            </p>
            <p className="hero-description">
              A dynamic and research-driven academic professional with over 16 years of experience 
              in teaching and research, specializing in Accounting and Financial Management. 
              Recognized for strong public communication skills and effective leadership in 
              academic settings.
            </p>

            {/* Key Stats */}
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">16+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">20+</div>
                <div className="stat-label">Research Papers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">5+</div>
                <div className="stat-label">Patents & Designs</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10+</div>
                <div className="stat-label">Books & Chapters</div>
              </div>
            </div>

            {/* Quick Info */}
            <div className="quick-info">
              <div className="info-item">
                <span className="info-label">Current Position:</span>
                <span className="info-value">Assistant Professor, Pimpri Chinchwad University</span>
              </div>
              <div className="info-item">
                <span className="info-label">Specialization:</span>
                <span className="info-value">Accounting & Financial Management</span>
              </div>
              <div className="info-item">
                <span className="info-label">Research Focus:</span>
                <span className="info-value">AI in Finance, Climate Economics, Digital Education</span>
              </div>
            </div>

            {/* CTA Buttons */}
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;